import { Materials } from '../Materials';

// import { FAQTab } from './FAQTab';
import { InstructionsTab } from './InstructionsTab';
import { InterwillInfoPanelTabsType } from './types';

export const tabs: InterwillInfoPanelTabsType = [
  {
    iconName: 'play',
    title: 'Materials',
    content: <Materials key={0} />,
  },
  {
    iconName: 'book-open-text',
    title: 'Instructions',
    content: <InstructionsTab key={1} />,
  },
  // {
  //   iconName: 'question',
  //   title: 'FAQ',
  //   content: <FAQTab key={2} />,
  // },
];
